import React from 'react';
import {
	TableCellGroup,
	TableRow,
	TableCellGroupDiv,
	Label,
	TableCellMin,
	TableCellChart,
	SelectedTopBox,
	SlectedPercentageBox,
} from '../CategoryHierarchy/CategoryHierarchy.styles';

function TableRowsWithSelectedOptions({ name, metricsData, index }) {
	function formatNumber(value, decimalPlaces = 0) {
		return Number.isInteger(value)
			? value.toString()
			: value.toFixed(decimalPlaces);
	}
	return (
		<div style={{ borderBottom: '1px solid #d4d4d4', marginTop: '10px' }}>
			<Label
				style={{ fontSize: '17px', fontWeight: 'bold', marginLeft: '10px' }}
			>
				{' '}
				{name}{' '}
			</Label>
			<div
				style={{
					display: 'flex',
					marginTop: '15px',
					marginBottom: '15px',
					justifyContent: 'normal',
					columnGap: '1rem',
					marginLeft: '10px',
					marginRight: '10px',
				}}
			>
				{metricsData?.length > 0 ? (
					metricsData.map(item => {
						return (
							<div
								key={item.lable}
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<SelectedTopBox
									title={item.lable}
									$showMarker={item.showMarker}
									$labelLength={item.lable.length}
									style={{ width: '8.7rem', height: '4rem', textAlign: 'left' }} // Fixed size
								>
									{item.lable}
								</SelectedTopBox>
								<SlectedPercentageBox
									style={{ width: '8.7rem', height: '1.9rem' }} // Fixed size
								>
									{formatNumber(item.value)}%
								</SlectedPercentageBox>
							</div>
						);
					})
				) : (
					<>No data available</>
				)}
			</div>
		</div>
	);
}

export default TableRowsWithSelectedOptions;
